/**************************************************
 * Nombre:       Pagina
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Fab, Grid} from "@mui/material";
import {BrowserRouter as Router, Route, Routes} from 'react-router';
import {useResponsive} from "../Modulo_responsive/Hooks/useResponsive";
import Barra from "./Barra/Barra";
import Footer from "./Footer";
import Home from "./Secciones/Home";
import Catalogo from "./Secciones/Catalogo";
import Detalle_Producto from "./Secciones/Detalle_Producto";
import Seccion_Checkout from "./Secciones/Seccion_Checkout";
import {WhatsApp} from '@mui/icons-material'
import {iniciarChatWass} from "../Utilidades/iniciarChatWass";

const Pagina = () => {
    const {sCell, masSM} = useResponsive()

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Router>

                <Grid item container size={12} sx={{
                    justifyContent: 'flex-start', position: sCell ? 'relative' : 'sticky', top: '0%', zIndex: 4
                }}>
                    <Barra/>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>

                    <Routes>

                        <Route path={"/"} element={<Home/>}/>
                        <Route path={"/Home"} element={<Home/>}/>
                        <Route path={"/*"} element={<Home/>}/>
                        <Route path={"/Portafolio"} element={<Catalogo/>}/>
                        <Route path={"/Portafolio/:id"} element={<Catalogo/>}/>
                        <Route path={"/Detalle"} element={<Detalle_Producto/>}/>
                        <Route path={"/Detalle/:id"} element={<Detalle_Producto/>}/>
                        <Route path={"/Checkout"} element={<Seccion_Checkout/>}/>

                    </Routes>


                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}}
                      sx={{justifyContent: 'flex-start', position: 'fixed', bottom: 24, left: 24}}>
                    <Fab
                        onClick={() => iniciarChatWass({mensaje: 'Hola Nariño Souvenirs'})}
                        size={'large'} sx={{backgroundColor: '#075E54', '&:hover': {backgroundColor: '#075E5480'}}}>
                        <WhatsApp sx={{fill: '#fff', height: 32, width: 32}}/>
                    </Fab>
                </Grid>

                <Grid item container size={12}
                      sx={{justifyContent: 'flex-start', marginTop: masSM ? 24 : 10}}>
                    <Footer/>
                </Grid>

            </Router>

        </Grid>
    )

}
export default Pagina